var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":"info"},on:{"click":_vm.nextStep}},[_vm._v("Continue")])}
var staticRenderFns = []

export { render, staticRenderFns }